import { GridCellParams, GridColDef, GridColumnHeaderParams, GridValidRowModel } from '@mui/x-data-grid-pro';
import IDCell from './Cells/IDCell/IDCell';
import ProjectDeptCell from './Cells/ProjectDeptCell/ProjectNameCell';
import CustomerCell from './Cells/CustomerCell/CustomerCell';
import AffairNameCell from './Cells/AffairNameCell/AffairNameCell';
import ConsultantCell from './Cells/ConsultantCell/ConsultantCell';
import AffairOtpCell from './Cells/AffairOtpCell/AffairOtpCell';
import OrderIdCell from './Cells/OrderIdCell/OrderIdCell';
import ForcastedDateCell from './Cells/ForcastedDateCell/ForcastedDateCell';
import DeliveryManagerCell from './Cells/DeliveryManagerCell/DeliveryManagerCell';
import BmCell from './Cells/BmCell/BmCell';
import RatingCell from './Cells/RatingCell/RatingCell';
import WorkunitNameCell from './Cells/WorkunitNameCell/WorkunitNameCell';
import WorkunitReferenceCell from './Cells/WorkunitReferenceCell/WorkunitReferenceCell';
import PriceCell from './Cells/PriceCell/PriceCell';
import WorkloadCell from './Cells/WorkloadCell/WorkloadCell';
import ScopeCell from './Cells/ScopeCell/ScopeCell';
import PendingAtCell from './Cells/PendingAtCell/PendingAtCell';
import OrderStatusCell from './Cells/OrderStatusCell/OrderStatusCell';
import ClientCell from './Cells/ClientCell/ClientCell';
import RefSpecCell from './Cells/RefSpecCell/RefSpecCell';
import NameSpecCell from './Cells/NameSpecCell/NameSpecCell';
import useUserRoles from 'hooks/useUserRoles';
import { find, forEach, map } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import MissionComment from 'types/entities/MissionComment';
import DashboardKpiMetric from 'types/entities/DashboardKpiMetric';
import Scope from 'types/entities/Scope';
import User from 'types/entities/User';
import { useSelector } from 'store/hooks';
import { KpiMetricTableType } from 'types/enums/KpiMetricTableType';

// type KpiWorkunitGridData = {
//   order?: { affair?: { name?: string } };
//    order?:
// };

type KpiWorkunitGridCellParams<T> = GridCellParams<T, DashboardKpiMetric, any>;

export const columnField = {
  PROJECT_DEPT: 'bu',
  CUSTOMER: 'customer',
  AFFAIR_NAME: 'Affair_name',
  CONSULTANT: 'consultant_fullname',
  AFFAIROTP: 'affair_otp',
  ORDER_ID: 'Order_number',
  FORECASTED_DATE: 'delivery_date',
  DELIVERY_MANAGER: 'delivery_manager',
  BM: 'bm',
  RATING: 'rating',
  WORKUNIT_NAME: 'workunit_name',
  WORKUNIT_REFERENCE: 'workunit_reference',
  PRICE: 'price',
  WORKLOAD: 'workload',
  SCOPE: 'scope',
  PENDINGAT: 'pendingat',
  ORDER_STATUS: 'Status',
  CLIENT: 'client_fullname',
  REF_SPEC: 'Ref_spec',
  NAME_SPEC: 'Name_spec',
  ID: 'id',
} as const;

const defaultColumnParams: GridColDef = {
  field: '',
  headerName: '',
  align: 'left',
  headerAlign: 'center',
  filterable: false,
  sortable: true,
  flex: 1,
};

export const columnsParams: GridColDef[] = [
  {
    field: columnField.ID,
    headerName: 'Id',
    renderCell: (params: KpiWorkunitGridCellParams<number>) => <IDCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.PROJECT_DEPT,
    headerName: 'BU',
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <ProjectDeptCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.CUSTOMER,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <CustomerCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.AFFAIR_NAME,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <AffairNameCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.CONSULTANT,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <ConsultantCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.AFFAIROTP,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <AffairOtpCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.ORDER_ID,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <OrderIdCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.FORECASTED_DATE,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <ForcastedDateCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.DELIVERY_MANAGER,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <DeliveryManagerCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.BM,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <BmCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.RATING,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <RatingCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.WORKUNIT_NAME,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <WorkunitNameCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.WORKUNIT_REFERENCE,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <WorkunitReferenceCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.PRICE,
    renderCell: (params: KpiWorkunitGridCellParams<number>) => <PriceCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.WORKLOAD,
    renderCell: (params: KpiWorkunitGridCellParams<['charge']>) => <WorkloadCell {...params.row} />,
    minWidth: 60,
  },
  {
    field: columnField.SCOPE,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <ScopeCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.PENDINGAT,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <PendingAtCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.ORDER_STATUS,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <OrderStatusCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.CLIENT,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <ClientCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.REF_SPEC,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <RefSpecCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
  {
    field: columnField.NAME_SPEC,
    renderCell: (params: KpiWorkunitGridCellParams<string>) => <NameSpecCell {...params.row} />,
    resizable: true,
    align: 'center',
    minWidth: 100,
    sortable: true,
  },
];

type ColumnsFields = { [name: string]: string[] };

export const kpiMetricColumnsFields: ColumnsFields = {
  [KpiMetricTableType.WORKFLOW]: [
    columnField.PROJECT_DEPT,
    columnField.CUSTOMER,
    columnField.AFFAIR_NAME,
    columnField.CONSULTANT,
    columnField.AFFAIROTP,
    columnField.ORDER_ID,
    columnField.FORECASTED_DATE,
    columnField.DELIVERY_MANAGER,
    columnField.BM,
    columnField.RATING,
    columnField.WORKUNIT_NAME,
    columnField.WORKUNIT_REFERENCE,
    columnField.PRICE,
    columnField.WORKLOAD,
    columnField.SCOPE,
    columnField.PENDINGAT,
    columnField.ORDER_STATUS,
    columnField.CLIENT,
    columnField.REF_SPEC,
    columnField.NAME_SPEC,
    columnField.ID,
  ],
  [KpiMetricTableType.ACCEPTANCE]: [
    columnField.PROJECT_DEPT,
    columnField.CUSTOMER,
    columnField.AFFAIR_NAME,
    columnField.CONSULTANT,
    columnField.AFFAIROTP,
    columnField.ORDER_ID,
    columnField.FORECASTED_DATE,
    columnField.DELIVERY_MANAGER,
    columnField.BM,
    columnField.RATING,
    columnField.WORKUNIT_NAME,
    columnField.WORKUNIT_REFERENCE,
    columnField.PRICE,
    columnField.WORKLOAD,
    columnField.SCOPE,
    columnField.PENDINGAT,
    columnField.ORDER_STATUS,
    columnField.CLIENT,
    columnField.REF_SPEC,
    columnField.NAME_SPEC,
    columnField.ID,
  ],
  [KpiMetricTableType.PERFORMANCE]: [
    columnField.PROJECT_DEPT,
    columnField.CUSTOMER,
    columnField.AFFAIR_NAME,
    columnField.CONSULTANT,
    columnField.AFFAIROTP,
    columnField.ORDER_ID,
    columnField.FORECASTED_DATE,
    columnField.DELIVERY_MANAGER,
    columnField.BM,
    columnField.RATING,
    columnField.WORKUNIT_NAME,
    columnField.WORKUNIT_REFERENCE,
    columnField.PRICE,
    columnField.WORKLOAD,
    columnField.SCOPE,
    columnField.PENDINGAT,
    columnField.ORDER_STATUS,
    columnField.CLIENT,
    columnField.REF_SPEC,
    columnField.NAME_SPEC,
    columnField.ID,
  ],
};

/**
 * React hook to build columns variable for Mui Datagrid with specific components
 */
export const useColumns = (columnsFields: ColumnsFields, order_type_id: number) => {
  const [t] = useTranslation();
  const userRoles = useUserRoles();
  // const state = useSelector((state) => state.deliverable);
  return useMemo(() => {
    const columns: { [name: string]: GridColDef<DashboardKpiMetric, any, any>[] } = {};
    forEach(columnsFields, (fields, name) => {
      columns[name] = map(fields, (field) => {
        const columnParam = find(columnsParams, ['field', field]);
        return {
          ...defaultColumnParams,
          ...columnParam,
          ...{ headerName: t(field) },
        };
      });
    });
    return columns;
  }, [columnsFields, userRoles, t]);
};
